(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-desk-obsession"] && !Shopify.designMode) return;
  try {
    if(!window.ggDeskPurchaseBound){document.addEventListener('click',event=>{if(!event.target.closest('[data-gg-purchase]'))return;const primary=document.querySelector('.gg-refined button[name="add"]');if(primary&&!primary.disabled)primary.click();});window.ggDeskPurchaseBound=true;}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-other-models"] && !Shopify.designMode) return;
  try {
    if(!window.ggRelatedBound){document.addEventListener('click',event=>{const button=event.target.closest('[data-gg-slide]');if(!button)return;const track=button.closest('.gg-related').querySelector('.gg-related-track');track.scrollBy({left:Number(button.dataset.ggSlide)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});window.ggRelatedBound=true;}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-product-refined"] && !Shopify.designMode) return;
  try {
    
 if (!customElements.get('gg-product-landing')) customElements.define('gg-product-landing', class extends HTMLElement {
   connectedCallback() {
     if (this.initialized) return; this.initialized = true;
     const belowCartModels=["miniature-mk22-tan-model","m1-garand","stg44-model","mini-sig-mcx-black","desert-eagle-black","desert-eagle-model-silver","desert-eagle-model-gold","mini-rpg","black-sniper-model","realtree-sniper-model","mini-svd-sniper","miniature-m1a1-tsmg-model","veteran-kit","mini-50cal-barrett"];
     const forceBelowCart=belowCartModels.includes(this.dataset.productHandle);
     const attachmentUpsells=this.querySelector('.gg-selleasy-inline');
     const collectionUpsells=this.querySelector('[data-gg-collection-upsells]');
     const positionSelleasy=()=>{
       this.querySelectorAll('lb-upsell-widget').forEach(widget=>{
         const headings=[...widget.querySelectorAll('.lb-addon-title,.lb-fbt-title,[role="heading"],h2,h3')].map(el=>el.textContent.trim()).join(' ');
         if(!headings&&!forceBelowCart)return;
         const isDiscountAttachment=/20\s*%\s*off/i.test(widget.textContent)&&/attachment/i.test(headings);
         const collectionOffer=!isDiscountAttachment&&(forceBelowCart||/shop\s+the\s+collection|frequently\s+bought\s+together/i.test(headings));
         if(collectionOffer&&widget.parentElement!==collectionUpsells)collectionUpsells.appendChild(widget);
       });
     };
     this.selleasyPositionObserver=new MutationObserver(positionSelleasy);
     this.selleasyPositionObserver.observe(this,{childList:true,subtree:true,characterData:true});
     positionSelleasy();
     const track=this.querySelector('.gg-thumbs');const previous=this.querySelector('[data-gg-gallery-prev]');const next=this.querySelector('[data-gg-gallery-next]');const updateGalleryArrows=()=>{previous.hidden=track.scrollLeft<2;next.hidden=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};previous.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));track.addEventListener('scroll',updateGalleryArrows,{passive:true});this.galleryObserver=new ResizeObserver(updateGalleryArrows);this.galleryObserver.observe(track);updateGalleryArrows();
     const video=this.querySelector('video');const initialImage=this.querySelector('.gg-main-image');if(video&&initialImage){initialImage.hidden=true;video.muted=true;video.play().catch(()=>{});this.querySelectorAll('.gg-thumb').forEach(item=>item.removeAttribute('aria-current'));this.querySelector('[data-gg-show-video]')?.setAttribute('aria-current','true');}this.querySelector('[data-gg-show-video]')?.addEventListener('click',()=>{initialImage.hidden=true;video.hidden=false;video.muted=true;video.play().catch(()=>{});this.querySelectorAll('.gg-thumb').forEach(item=>item.removeAttribute('aria-current'));this.querySelector('[data-gg-show-video]').setAttribute('aria-current','true');});
     const main = this.querySelector('.gg-main-image');
     this.querySelectorAll('[data-image].gg-thumb').forEach(link => link.addEventListener('click', event => {
       if (!main) return; event.preventDefault(); if(video){video.pause();video.hidden=true;main.hidden=false;} main.src = link.dataset.image; main.removeAttribute('srcset'); main.alt = link.dataset.alt;
       this.querySelectorAll('.gg-thumb').forEach(item => item.removeAttribute('aria-current')); link.setAttribute('aria-current', 'true');
     }));
     const stage=this.querySelector('.gg-image-stage');
     const mobileMedia=matchMedia('(max-width:899px)');
     const mediaButtons=[...this.querySelectorAll('.gg-thumb')];
     const toggle=this.querySelector('.gg-video-toggle');
     const syncVideo=()=>{
       if(!video||!toggle)return;
       video.controls=!mobileMedia.matches;
       video.playsInline=true;
       video.defaultMuted=true;
       toggle.hidden=!mobileMedia.matches||video.hidden;
       toggle.textContent=video.paused?'Play':'Pause';
       toggle.setAttribute('aria-label',video.paused?'Play product video':'Pause product video');
     };
     if(video){
       video.addEventListener('play',syncVideo);video.addEventListener('pause',syncVideo);
       toggle.addEventListener('click',()=>{if(video.paused)video.play().catch(()=>{});else video.pause();});
       mobileMedia.addEventListener('change',syncVideo);
       new MutationObserver(syncVideo).observe(video,{attributes:true,attributeFilter:['hidden']});
       syncVideo();
     }
     let swipeStart=null;
     stage.addEventListener('touchstart',event=>{
       if(!mobileMedia.matches||event.touches.length!==1){swipeStart=null;return;}
       swipeStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
     },{passive:true});
     stage.addEventListener('touchend',event=>{
       if(!swipeStart)return;
       const start=swipeStart;swipeStart=null;
       const touch=event.changedTouches[0];if(!touch)return;
       const dx=touch.clientX-start.x,dy=touch.clientY-start.y;
       if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.3)return;
       const current=mediaButtons.findIndex(button=>button.getAttribute('aria-current')==='true');
       const index=Math.max(0,Math.min(mediaButtons.length-1,current+(dx<0?1:-1)));
       if(index===current||!mediaButtons[index])return;
       mediaButtons[index].click();
       const rail=mediaButtons[index].parentElement;
       rail.scrollTo({left:mediaButtons[index].offsetLeft-rail.clientWidth/2+mediaButtons[index].clientWidth/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
       syncVideo();
     },{passive:true});
     stage.addEventListener('touchcancel',()=>{swipeStart=null;},{passive:true});
     const select = this.querySelector('select[name="id"]');
     select.addEventListener('change', () => {
       const option = select.selectedOptions[0];
       this.querySelector('[data-price]').textContent = option.dataset.price;
       this.querySelector('[data-sticky-price]').textContent = option.dataset.price;
       const compare = this.querySelector('[data-compare]'); compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true';
       this.querySelectorAll('[data-add]').forEach(button => { button.disabled = option.dataset.available !== 'true'; button.textContent = this.querySelector(button.disabled ? '[data-label-sold]' : '[data-label-add]').textContent; });
       if (option.dataset.image && main) { main.src = option.dataset.image; main.removeAttribute('srcset'); }
       const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
     });
     const sticky = this.querySelector('.gg-sticky');
     this.observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }, {threshold:0});
     this.observer.observe(this.querySelector('.gg-purchase-row'));
   }
   disconnectedCallback() { this.observer?.disconnect(); this.selleasyPositionObserver?.disconnect(); this.galleryObserver?.disconnect(); this.initialized = false; }
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-email-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hp-email] form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var section = form.closest('[data-hp-email]');
        var tag = form.querySelector('input[name="contact[tags]"]');
        var placement = tag ? tag.value.split(',').pop() || '' : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'hp_email_submit', placement: placement });
        document.dispatchEvent(new CustomEvent('hp_email_submit', { detail: { placement: placement } }));
        if (section) section.setAttribute('data-submitted', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function emit(name, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      document.dispatchEvent(new CustomEvent(name, { detail: payload || {} }));
    }

    document.querySelectorAll('.hp-hero [data-hp-event]').forEach(function (el) {
      el.addEventListener('click', function () {
        emit(el.getAttribute('data-hp-event'), { text: (el.textContent || '').trim() });
      });
    });

    document.querySelectorAll('[data-hp-hero-video]').forEach(function (wrap) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) {
        // Removing the element fires disconnectedCallback, which disconnects the
        // native video-player IntersectionObserver so the file is never fetched.
        var player = wrap.querySelector('video-player');
        if (player) player.remove();
        return;
      }
      // Fade in only once the native player has actually inserted a <video>.
      var obs = new MutationObserver(function () {
        if (wrap.querySelector('video')) {
          wrap.classList.add('is-ready');
          obs.disconnect();
        }
      });
      obs.observe(wrap, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function emit(name, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      document.dispatchEvent(new CustomEvent(name, { detail: payload || {} }));
    }

    document.querySelectorAll('[data-hp-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          // The theme's own button classes carry the styling: filled when selected,
          // outline when not. No custom colours anywhere.
          tab.classList.toggle('button-outline', !on);
          var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) {
            if (on) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          }
        });
        if (focus) tabs[index].focus();
        emit('hp_tab_switch', { tab: (tabs[index].textContent || '').trim() });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i, false);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            select(next, true);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
